export function isNonNullable<T>(value: T): value is NonNullable<T> {
  return value !== undefined && value !== null;
}

export type L1NonNullable<T extends Record<any, any>> = {
  [x in keyof T]: NonNullable<T[x]>;
};

export function isImmediateNonNullable<T extends Record<any, any>>(
  value: T | null | undefined,
): value is L1NonNullable<T> {
  if (value === null || value === undefined) return false;
  return !Object.values(value).some(v => v === null || v === undefined);
}
export function isDefined<T>(value: T): value is Exclude<T, undefined> {
  return value !== undefined;
}
